module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/amps-8c954318eeafc538941cc2313c1c2aed.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/amps.svg
// module id = DKRS
// module chunks = 24